export enum ScreenType {
  TIME_V2 = 'TIME_V2',
  DATE_PICKER_V2 = 'DATE_PICKER_V2',
  SPLIT = 'SPLIT',
  PRELANDING_PALMISTRY = 'PRELANDING_PALMISTRY',
  GENDER = 'GENDER',
  UPSELL_INFO = 'UPSELL_INFO',
  UPSELL_CONSULTATION_V2 = 'UPSELL_CONSULTATION_V2',
  DYNAMIC_ANSWER = 'DYNAMIC_ANSWER',
  DYNAMIC_ANSWER_V2 = 'DYNAMIC_ANSWER_V2',
  GENDER_MOON_COMPATIBILITY = 'GENDER_MOON_COMPATIBILITY',
  GENDER_PALMISTRY = 'GENDER_PALMISTRY',
  GOAL = 'GOAL',
  WHICH_FIGURE = 'WHICH_FIGURE',
  GOAL_SET = 'GOAL_SET',
  DATE = 'DATE',
  DATE_PALMISTRY = 'DATE_PALMISTRY',
  DATE_NATAL_CHART = 'DATE_NATAL_CHART',
  DATE_NATAL_CHART_V2 = 'DATE_NATAL_CHART_V2',
  PLACE = 'PLACE',
  PLACE_NATAL_CHART = 'PLACE_NATAL_CHART',
  PLACE_HUMAN_DESIGN = 'PLACE_HUMAN_DESIGN',
  NAME = 'NAME',
  TIME = 'TIME',
  TIME_NATAL_CHART = 'TIME_NATAL_CHART',
  INFORMATIONAL = 'INFORMATIONAL',
  INFORMATIONAL_V2 = 'INFORMATIONAL_V2',
  INFORMATIONAL_DYNAMIC = 'INFORMATIONAL_DYNAMIC',
  INFORMATIONAL_PALMISTRY = 'INFORMATIONAL_PALMISTRY',
  INFORMATIONAL_NATAL_CHART = 'INFORMATIONAL_NATAL_CHART',
  IMAGE_INFORMATIONAL = 'IMAGE_INFORMATIONAL',
  COMPOUNDED_TITLE_INFORMATIONAL = 'COMPOUNDED_TITLE_INFORMATIONAL',
  ANSWER = 'ANSWER',
  ANSWER_EMOJI = 'ANSWER_EMOJI',
  ANSWER_GOAL = 'ANSWER_GOAL',
  ANSWER_PALMISTRY = 'ANSWER_PALMISTRY',
  ANSWER_GOAL_PALMISTRY = 'ANSWER_GOAL_PALMISTRY',
  ANSWER_NATAL_CHART = 'ANSWER_NATAL_CHART',
  ANSWER_GOAL_NATAL_CHART = 'ANSWER_GOAL_NATAL_CHART',
  ANSWER_NATAL_CHART_V2 = 'ANSWER_NATAL_CHART_V2',
  ANSWER_HORIZONTAL_ORIENTATION = 'ANSWER_HORIZONTAL_ORIENTATION',
  ANSWER_GOAL_HORIZONTAL_ORIENTATION = 'ANSWER_GOAL_HORIZONTAL_ORIENTATION',
  ANSWER_HORIZONTAL_ORIENTATION_V2 = 'ANSWER_HORIZONTAL_ORIENTATION_V2',
  MULTIPLE_ANSWERS = 'MULTIPLE_ANSWERS',
  MULTIPLE_ANSWERS_V2 = 'MULTIPLE_ANSWERS_V2',
  MULTIPLE_ANSWERS_NATAL_CHART = 'MULTIPLE_ANSWERS_NATAL_CHART',
  MULTIPLE_ANSWERS_NATAL_CHART_V2 = 'MULTIPLE_ANSWERS_NATAL_CHART_V2',
  PROBLEM = 'PROBLEM',
  EMAIL = 'EMAIL',
  EMAIL_PALMISTRY = 'EMAIL_PALMISTRY',
  EMAIL_NATAL_CHART = 'EMAIL_NATAL_CHART',
  EMAIL_CONFIRM = 'EMAIL_CONFIRM',
  EMAIL_CONFIRM_PALMISTRY = 'EMAIL_CONFIRM_PALMISTRY',
  EMAIL_CONFIRM_NATAL_CHART = 'EMAIL_CONFIRM_NATAL_CHART',
  PROCESSING = 'PROCESSING',
  PROCESSING_PALMISTRY = 'PROCESSING_PALMISTRY',
  PROCESSING_NATAL_CHART = 'PROCESSING_NATAL_CHART',
  PROCESSING_LOADER = 'PROCESSING_LOADER',
  REVIEW = 'REVIEW',
  ONBOARDING = 'ONBOARDING',
  ONBOARDING_PALMISTRY = 'ONBOARDING_PALMISTRY',
  SCAN_PREVIEW = 'SCAN_PREVIEW',
  SCAN_PREVIEW_V2 = 'SCAN_PREVIEW_V2',
  SCAN = 'SCAN',
  SCAN_WITH_PREVIEW = 'SCAN_WITH_PREVIEW',
  SCAN_WITH_SKIP_ERROR = 'SCAN_WITH_SKIP_ERROR',
  SCAN_V2 = 'SCAN_V2',
  SCAN_ANALYSING = 'SCAN_ANALYSING',
  SCAN_ANALYSING_V2 = 'SCAN_ANALYSING_V2',
  SCAN_ANALYSING_WITH_UPDATE_SETTINGS = 'SCAN_ANALYSING_WITH_UPDATE_SETTINGS',
  SCAN_ANALYSING_COMPLETED = 'SCAN_ANALYSING_COMPLETED',
  REPORT = 'REPORT',
  SINGLE_ZODIAC_INFO = 'SINGLE_ZODIAC_INFO',
  RELATIONSHIP_ZODIAC_INFO = 'RELATIONSHIP_ZODIAC_INFO',
  LIMITED_CHOICE = 'LIMITED_CHOICE',
  MENTIONED_IN = 'MENTIONED_IN',
  /** @deprecated use UPSELLS_WITH_CONTENT */
  UPSELLS = 'UPSELLS',
  UPSELLS_V3 = 'UPSELLS_V3',
  UPSELLS_WITH_CONTENT = 'UPSELLS_WITH_CONTENT',
  SOCIAL_PROOF = 'SOCIAL_PROOF',
  UPSELL_CONSULTATION = 'UPSELL_CONSULTATION',
  UPSELL_CONSULTATION_WITH_DISCOUNT = 'UPSELL_CONSULTATION_WITH_DISCOUNT',
  UPSELL_READINGS_PACK = 'UPSELL_READINGS_PACK',
  UPSELL_READINGS_PACK_WITH_DISCOUNT = 'UPSELL_READINGS_PACK_WITH_DISCOUNT',
  SUMMARY = 'SUMMARY',
  SUMMARY_V2 = 'SUMMARY_V2',
  STORIES = 'STORIES',
  TIMELINE = 'TIMELINE',
  LOADER_WITH_REVIEWS = 'LOADER_WITH_REVIEWS',
  UPSELLS_PALMISTRY_V2 = 'UPSELLS_PALMISTRY_V2',
  UPSELLS_NATAL_CHART = 'UPSELLS_NATAL_CHART',
  /** @deprecated only competitor_flow use it */
  UNLIMITED_READINGS = 'UNLIMITED_READINGS',
  /** @deprecated use TRIAL_CREDITS_WITH_CONTENT */
  TRIAL_CREDITS = 'TRIAL_CREDITS',
  TRIAL_CREDITS_WITH_CONTENT = 'TRIAL_CREDITS_WITH_CONTENT',
  TRIAL_CREDITS_PALMISTRY = 'TRIAL_CREDITS_PALMISTRY',
  TRIAL_CREDITS_PALMISTRY_V2 = 'TRIAL_CREDITS_PALMISTRY_V2',
  TRIAL_CREDITS_NATAL_CHART = 'TRIAL_CREDITS_NATAL_CHART',
  ADDITIONAL_DISCOUNT = 'ADDITIONAL_DISCOUNT',
  ADDITIONAL_DISCOUNT_V2 = 'ADDITIONAL_DISCOUNT_V2',
  ADDITIONAL_DISCOUNT_PALMISTRY = 'ADDITIONAL_DISCOUNT_PALMISTRY',
  ADDITIONAL_DISCOUNT_PALMISTRY_V2 = 'ADDITIONAL_DISCOUNT_PALMISTRY_V2',
  CREDITS = 'CREDITS',
  CREDITS_NATAL_CHART = 'CREDITS_NATAL_CHART',
  LOADING_ASK = 'LOADING_ASK',
  LOADING_ASK_PALMISTRY = 'LOADING_ASK_PALMISTRY',
  LOADING_ASK_NATAL_CHART = 'LOADING_ASK_NATAL_CHART',
  ONBOARDING_ASK = 'ONBOARDING_ASK',
  ONBOARDING_ASK_V2 = 'ONBOARDING_ASK_V2',
  ONBOARDING_ASK_PALMISTRY = 'ONBOARDING_ASK_PALMISTRY',
  ONBOARDING_ASK_NATAL_CHART = 'ONBOARDING_ASK_NATAL_CHART',
  QUESTIONS = 'QUESTIONS',
  QUESTIONS_PALMISTRY = 'QUESTIONS_PALMISTRY',
  QUESTIONS_NATAL_CHART = 'QUESTIONS_NATAL_CHART',
  TALK_WITH_EXPERT = 'TALK_WITH_EXPERT',
  TALK_WITH_EXPERT_PALMISTRY = 'TALK_WITH_EXPERT_PALMISTRY',
  TALK_WITH_EXPERT_NATAL_CHART = 'TALK_WITH_EXPERT_NATAL_CHART',
  TRIAL_CHOICE = 'TRIAL_CHOICE',
  TRIAL_CHOICE_NATAL_CHART = 'TRIAL_CHOICE_NATAL_CHART',
  TRIAL_CHOICE_PALMISTRY_V2 = 'TRIAL_CHOICE_PALMISTRY_V2',
  TRIAL_PAYMENT_WITH_DISCOUNT = 'TRIAL_PAYMENT_WITH_DISCOUNT',
  TRIAL_PAYMENT_WITH_DISCOUNT_PALMISTRY_V2 = 'TRIAL_PAYMENT_WITH_DISCOUNT_PALMISTRY_V2',
  TRIAL_PAYMENT = 'TRIAL_PAYMENT',
  TRIAL_PAYMENT_V2 = 'TRIAL_PAYMENT_V2',
  TRIAL_PAYMENT_V3 = 'TRIAL_PAYMENT_V3',
  TRIAL_PAYMENT_HUMAN_DESIGN = 'TRIAL_PAYMENT_HUMAN_DESIGN',
  TRIAL_PAYMENT_WITCH_POWER = 'TRIAL_PAYMENT_WITCH_POWER',
  TRIAL_PAYMENT_WITCH_POWER_V2 = 'TRIAL_PAYMENT_WITCH_POWER_V2',
  PAYWALL_WITH_TRIAL_CHOICE = 'PAYWALL_WITH_TRIAL_CHOICE',
  TRIAL_PAYMENT_PALMISTRY_V2 = 'TRIAL_PAYMENT_PALMISTRY_V2',
  TRIAL_PAYMENT_PALMISTRY_V3 = 'TRIAL_PAYMENT_PALMISTRY_V3',
  TRIAL_PAYMENT_MOON_COMPATIBILITY = 'TRIAL_PAYMENT_MOON_COMPATIBILITY',
  TRIAL_PAYMENT_NATAL_CHART = 'TRIAL_PAYMENT_NATAL_CHART',
  TRIAL_PAYMENT_NATAL_CHART_V3 = 'TRIAL_PAYMENT_NATAL_CHART_V3',
  TRIAL_PAYMENT_NATAL_CHART_V4 = 'TRIAL_PAYMENT_NATAL_CHART_V4',
  TRIAL_PAYMENT_NATAL_CHART_SECTIONS = 'TRIAL_PAYMENT_NATAL_CHART_SECTIONS',
  /** @deprecated */
  TRIAL_PAYMENT_INTRO_OFFER_V2 = 'TRIAL_PAYMENT_INTRO_OFFER_V2',
  PHONE_NUMBER = 'PHONE_NUMBER',
  PHONE_NUMBER_PALMISTRY = 'PHONE_NUMBER_PALMISTRY',
  MOON_PHASE = 'MOON_PHASE',
  PARTNER_MOON_PHASE = 'PARTNER_MOON_PHASE',
  THANK_YOU = 'THANK_YOU',
  THANK_YOU_WITH_REDIRECT = 'THANK_YOU_WITH_REDIRECT',
  PRELANDING_MOON_COMPATIBILITY = 'PRELANDING_MOON_COMPATIBILITY',
  NAME_MOON_COMPATIBILITY = 'NAME_MOON_COMPATIBILITY',
  NAME_MOON_COMPATIBILITY_V2 = 'NAME_MOON_COMPATIBILITY_V2',
  LOADING_MOON_COMPATIBILITY = 'LOADING_MOON_COMPATIBILITY',
  EMAIL_MARKETING = 'EMAIL_MARKETING',
  /** @deprecated */
  EMAIL_MARKETING_WITCH_POWER = 'EMAIL_MARKETING_WITCH_POWER',
  UPSELL_SHORT = 'UPSELL_SHORT',
  /** @deprecated */
  EMAIL_MARKETING_NATAL_CHART = 'EMAIL_MARKETING_NATAL_CHART',
  /** @deprecated */
  EMAIL_MARKETING_PALMISTRY = 'EMAIL_MARKETING_PALMISTRY',
  /** @deprecated */
  EMAIL_MARKETING_COMPATIBILITY = 'EMAIL_MARKETING_COMPATIBILITY',
  EMAIL_MARKETING_COMPATIBILITY_ONE_TIME_PAYMENT = 'EMAIL_MARKETING_COMPATIBILITY_ONE_TIME_PAYMENT',
  HELLO_MOON_COMPATIBILITY = 'HELLO_MOON_COMPATIBILITY',
  EMAIL_BLURRED = 'EMAIL_BLURRED',
  USER_TYPE_HUMAN_DESIGN = 'USER_TYPE_HUMAN_DESIGN',
  NAME_HUMAN_DESIGN = 'NAME_HUMAN_DESIGN',
  RELATIONSHIP_PROGRESS = 'RELATIONSHIP_PROGRESS',
  /** @deprecated */
  TRIAL_PAYMENT_ATTACHMENT_STYLE = 'TRIAL_PAYMENT_ATTACHMENT_STYLE',
  TRIAL_PAYMENT_ATTACHMENT_STYLE_V3 = 'TRIAL_PAYMENT_ATTACHMENT_STYLE_V3',
  GENDER_V2 = 'GENDER_V2',
  GENDER_V3 = 'GENDER_V3',
  GENDER_V4 = 'GENDER_V4',
  GENDER_V5 = 'GENDER_V5',
  /** @deprecated */
  TRIAL_PAYMENT_ATTACHMENT_STYLE_WITH_DISCOUNT = 'TRIAL_PAYMENT_ATTACHMENT_STYLE_WITH_DISCOUNT',
  TRIAL_PAYMENT_ATTACHMENT_STYLE_WITH_DISCOUNT_V3 = 'TRIAL_PAYMENT_ATTACHMENT_STYLE_WITH_DISCOUNT_V3',
  TRIAL_PAYMENT_WITH_DISCOUNT_PALMISTRY_V3 = 'TRIAL_PAYMENT_WITH_DISCOUNT_PALMISTRY_V3',
  ANSWER_IMAGE = 'ANSWER_IMAGE',
  ANSWER_IMAGE_MULTIPLE = 'ANSWER_IMAGE_MULTIPLE',
  EMAIL_MARKETING_PAYWALL = 'EMAIL_MARKETING_PAYWALL',
  W2A_PROMOTION = 'W2A_PROMOTION',
  /** @deprecated */
  UPSELLS_EMAIL_MARKETING = 'UPSELLS_EMAIL_MARKETING',
  /** @deprecated */
  TRIAL_CREDITS_EMAIL_MARKETING = 'TRIAL_CREDITS_EMAIL_MARKETING',
  /** @deprecated */
  PHONE_NUMBER_EMAIL_MARKETING = 'PHONE_NUMBER_EMAIL_MARKETING',
  ECOMMERCE_PAYWALL = 'ECOMMERCE_PAYWALL',
  TRIAL_CHOICE_V2 = 'TRIAL_CHOICE_V2',
  TRIAL_CHOICE_WITH_SLIDER = 'TRIAL_CHOICE_WITH_SLIDER',

  NEB_ANSWER = 'NEB_ANSWER',
  NEB_ANSWER_GOAL = 'NEB_ANSWER_GOAL',
  NEB_GOAL = 'NEB_GOAL',
  NEB_MULTIPLE_ANSWERS = 'NEB_MULTIPLE_ANSWERS',
  NEB_ADDITIONAL_DISCOUNT = 'NEB_ADDITIONAL_DISCOUNT',
  NEB_SOCIAL_PROOF = 'NEB_SOCIAL_PROOF',
  NEB_SPLIT = 'NEB_SPLIT',
  NEB_ONBOARDING = 'NEB_ONBOARDING',
  NEB_LOADER_WITH_CONTENT = 'NEB_LOADER_WITH_CONTENT',
  NEB_DATE = 'NEB_DATE',
  NEB_TIME = 'NEB_TIME',
  NEB_TRIAL_CHOICE = 'NEB_TRIAL_CHOICE',
  NEB_TRIAL_PAYMENT = 'NEB_TRIAL_PAYMENT',
  NEB_GENDER = 'NEB_GENDER',
  NEB_EMAIL_CONFIRM = 'NEB_EMAIL_CONFIRM',
  NEB_RELATIONSHIP_ZODIAC = 'NEB_RELATIONSHIP_ZODIAC',
  NEB_UPSELLS = 'NEB_UPSELLS',
  NEB_TRIAL_CREDITS = 'NEB_TRIAL_CREDITS',
  NEB_PHONE_NUMBER = 'NEB_PHONE_NUMBER',
  NEB_TRIAL_PAYMENT_WITH_DISCOUNT = 'NEB_TRIAL_PAYMENT_WITH_DISCOUNT',
  NEB_W2A_PROMOTION = 'NEB_W2A_PROMOTION',
  NEB_ONBOARDING_ASK = 'NEB_ONBOARDING_ASK',
  NEB_EMAIL = 'NEB_EMAIL',
  NEB_PLACE = 'NEB_PLACE',
}
